import { SHORTCUTS, formatKeys } from "../../utils/shortcuts";

const ShortcutHint = ({ id, keys, className = "" }) => {
  const resolved = keys ?? SHORTCUTS[id]?.keys;
  if (!resolved) return null;

  const bindings = formatKeys(resolved);
  const kbdClass = "rounded border border-gray-200 bg-white px-1.5 py-0.5 font-sans text-xs font-medium leading-none text-gray-500";

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {bindings.map((steps, bindingIndex) => (
        <span key={bindingIndex} className="inline-flex items-center gap-1">
          {bindingIndex > 0 && <span className="text-xs text-gray-400">ou</span>}
          {steps.map((tokens, stepIndex) => (
            <span key={stepIndex} className="inline-flex items-center gap-0.5">
              {tokens.map((token, tokenIndex) => (
                <kbd key={tokenIndex} className={kbdClass}>
                  {token}
                </kbd>
              ))}
            </span>
          ))}
        </span>
      ))}
    </span>
  );
};

export default ShortcutHint;
